<template>
	<div class="abtconfirmSms">
		<loader v-if="isLoading" object="#65C523" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" disableScrolling="false" name="circular"></loader>
		<div class="formStepTitle"> Подтвердите номер телефона </div>
		<div id="asdasdasd">
			<formInput :refs="'SmsConfCode'"></formInput>
			<p> На ваш номер телефона отправлен код подтверждения </p>
			<p><a v-on:click="reSendCode" v-bind:class="{'canClick':timerCount <= 0}">Повторно отправить код</a> через {{ timerCount }} сек </p>
		</div>
		<div class="asp">
			<formCheckBox :name="'ASP'" :true-value="'true'" :false-value="'false'" ></formCheckBox>
			<p class="errorMsg" v-if="statusVuex['ASP'].ShowError">{{statusVuex['ASP'].msg}}</p>
			<a href="https://finmoll.ru/documents/soglashenie-ob-ispolzovanii-asp.pdf" target="_blank">Согласие об использовании аналога собственноручной подписи</a>
		</div>
	</div>
</template>
<script>
import {mapState, mapGetters} from 'vuex';
export default {
	name: "abtconfirmSms",
	data() {
		return {
			isLoading: false,
			allRigth: true,
			timerCount: 120,
			ConfirmationGUID: null,
			refsStepArr:[ 'SmsConfCode', 'ASP' ]
		}
	},
	components: {
		loader:       () => import('@/components/abt/loader_box'),
		formInput:    () => import('@/components/abt/form/abtInput'),
		formCheckBox: () => import('@/components/abt/form/abtCheckBox'),
	},
	mounted() {
		this.$store.dispatch('hideLoading');
		this.SMSConfirmationLid()
			.then((res)=>{ console.log('then'); console.log(res) })
			.catch((res)=>{ console.log('catch'); console.log(res) })
			.finally(()=>{ window.dblClick = false; });
		/**/
		if (window.ym) {
			// eslint-disable-next-line no-undef
			ym(51632228, 'reachGoal', 'varianB_contact');
		}
	},
	methods: {
		SMSConfirmationLid(){
			return new Promise(((resolve, reject) => {
				this.$palantir.trackAction(134,this.phoneVuex);
				this.$store.dispatch('showLoading');
				this.$myApi.SendRequest({
					action: 'SMSConfirmationLid',
					PHONE: this.phoneVuex,
				}).then((res) => {
					//console.log('then');
					//console.log('set GUID');
					//if(typeof res.ConfirmationGUID == 'string'){
						this.$palantir.trackAction(134,res.ConfirmationGUID);
						this.ConfirmationGUID = res.ConfirmationGUID;
						localStorage.setItem('ConfirmationGUID',res.ConfirmationGUID);
					//}
					resolve(res);
				}).catch((res) => {
					//console.log('catch');
					//console.log('get GUID');
					//console.log(localStorage.getItem('ConfirmationGUID'));
					this.$palantir.trackAction(135,JSON.stringify(res));
					let ErrorResult = this.$myApi.parseError(res, 'SMSConfirmationLid');
					reject(ErrorResult);
					this.ConfirmationGUID = localStorage.getItem('ConfirmationGUID');
					if(typeof res.ExecutionErrorMessage == 'string'){ alert(res.ExecutionErrorMessage) }
				})
				.finally(() => {
					this.$store.dispatch('hideLoading');
				});
			}));
		},
		reSendCode(){
			if (this.timerCount > 0) return false;
			this.timerCount = 120;
			this.$store.dispatch('saveSendData', { target: 'SmsConfCode', value: '' });
			this.SMSConfirmationLid()
				.then((res)=>{ console.log(res) })
				.catch((res)=>{ console.log(res) })
				.finally(()=>{ window.dblClick = false; });
		},
		/*
		insertPixel(src,tagg) {
			let pixel = document.createElement(tagg);
			pixel.src = src;
			if (tagg === 'img') {
				pixel.setAttribute('style','position:absolute;width:1px;height:1px;opacity:0;top:0;left:-100px;');
				let targetInsert = document.getElementById("app");
				document.body.insertBefore(pixel, targetInsert);
			} else if(tagg === 'script') {
				document.getElementsByTagName('head')[0].appendChild(pixel);
			}
		},
		sendData() {
			this.$palantir.trackAction(141,'');
			this.$store.dispatch('showLoading');
			let preSendData	=Object.assign({}, this.valueVuex);
			if (preSendData.CALC_SUMM < this.minBaseProduct.Amount) {
				//magic number, не трогай блиятть
				preSendData.CALC_SUMM = 25000;
			}
			if (preSendData.CALC_SUMM > this.maxBaseProduct.Amount) {
				preSendData.CALC_SUMM = this.maxBaseProduct.Amount;
			}
			this.$myApi.singleRequest({
				action:'SendRequest',
				data:preSendData
			}).then((res) => {
				this.$palantir.trackAction(142,JSON.stringify(res));
				if (res.pixel != undefined) {
					this.insertPixel(res.pixel,res.tagg);
				}
				this.$store.commit('saveSystemData',{ target:'loanid', value:res.loadnId });
				if (window.ym) {
					// eslint-disable-next-line no-undef
					ym(51632228, 'reachGoal', 'allRequest');
				}
				if (window.ga){
					// eslint-disable-next-line no-undef
					ga('send', 'event', 'admdForm', 'admdForm');
				}
				try {
					// eslint-disable-next-line no-undef
					VK.Goal('lead')
				} catch (e) {
					console.log(e);
				}
			this.$store.dispatch('hideLoading');
			this.$store.dispatch('formRouting', 'pdlThanks');
			}).catch((res) => {
				this.$palantir.trackAction(143,JSON.stringify(res));
				console.log(res);
			});
		},
		checkFormFieldValue(){
			//проверяем заполнения полей
			let isFormFieldCorrect = true;
			this.refsStepArr.forEach(item => {
				if (this.statusVuex[item].code != 0) {
					this.$palantir.trackAction(117,item);
					this.$store.dispatch('errorShow', {
						target: item,
						value: true,
					});
					isFormFieldCorrect = false;
				}
			});
			return isFormFieldCorrect;
		},
		manualError(str) {
			this.$store.dispatch('hideLoading');
			this.$store.dispatch('fieldError',{ target: 'SmsConfCode', value: str, });
		},
		logSmsConfCode(result){
			this.$myApi.singleRequest({ action:'logSmsConfCode', result:result }).then(res=>console.log(res))
			.catch(res=>console.log(res));
		},
		submitStep() {
			if (this.checkFormFieldValue()) {
				this.$store.dispatch('showLoading');
				this.$palantir.trackAction(137,this.ConfirmationCode);
				this.$myApi.SendRequest({
					action: 'SMSConfirmationCodeCheck',
					ConfirmationGUID: this.ConfirmationGUID,
					ConfirmationCode: this.ConfirmationCode,
				}).then(res => {
					if (res.CheckResult == true) {
						this.$palantir.trackAction(138,'');
						this.logSmsConfCode(1);
						this.sendData();
						console.log('sendingData')
					} else {
						this.$palantir.trackAction(139,'');
						this.logSmsConfCode(-1);
						this.manualError('Некорректный	код');
					}
					window.dblClick = false;
				}).catch((res) => {
					this.$palantir.trackAction(140,JSON.stringify(res));
					let ErrorResult = this.$myApi.parseError(res, 'SMSConfirmationLid');
					this.logSmsConfCode(-2);
					if (ErrorResult.ExecutionErrorCode > 0) {
						this.manualError('Некорректный	код');
					}
					window.dblClick = false;
				});
			} else {
				window.dblClick = false;
			}
		},
		*/
	},
	computed: {
		...mapState({
			ConfirmationCode: state => state.Form.sendData.SmsConfCode,
			phoneVuex:        state => state.Form.sendData.PHONE,
			errorCode:        state => state.Form.workData.PHONE.code,
			statusVuex:       state => state.Form.workData,
			systemFormVuex:   state => state.Form.system,
			valueVuex:        state => state.Form.sendData,
			minBaseProduct:   state => state.Deal.minBaseProduct,
			maxBaseProduct:   state => state.Deal.maxBaseProduct,
		}),
		...mapGetters(['isConfirmPhone']),
	},
	watch: {
		timerCount: {
			handler(value) { if (value > 0) { setTimeout(() => { this.timerCount--; }, 1000); } },
			immediate: true
		}
	}
}
</script>
<style scoped>
.abtconfirmSms {}
.abtconfirmSms div {}
.asp { padding: 1rem 0; }
.errorMsg { color: red; font-size: 1rem; }
.abtconfirmSms div p { font-size: .6rem; line-height: .6rem; }
.abtconfirmSms div a { font-size: .6rem; line-height: .6rem; }
.errorMsg { color: red; font-size: 1rem; }
.canClick { color: #45b537; }
@media screen and (min-width: 760px) {
	.abtconfirmSms div p { font-size: 1vw; line-height: 1vw; }
	.abtconfirmSms div a { font-size: 1vw; line-height: 1vw; }
	.errorMsg { color: red; font-size: 1rem; }
}
</style>
